import classNames from 'classnames';
import moment from 'moment';
import React, { forwardRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { isValidDate } from 'utils/date';

registerLocale( 'es', es );

type DateColumnrops = {
  value?: string
  onChange: ( value?: string ) => void
  placeholderLabel?: string
  className?: string
};

type CustomInputProps = {
  value?: string;
  onClick?: () => void;
  placeholderLabel?: string;
  className?: string;
};

const CustomInput = forwardRef<HTMLButtonElement, any>(
  ( {
    value, onClick, placeholderLabel = 'N/A', className,
  }: CustomInputProps, ref ) => (
    <button type="button" onClick={onClick} ref={ref} className={classNames( className, 'btn table-date-btn' )}>
      {isValidDate( value ) ? moment( new Date( value ) ).format( 'DD/MM/YYYY' ) : placeholderLabel}
    </button>
  ),
);

function DateColumn( { value, onChange, ...rest }: DateColumnrops ) {
  const [selectedDate, setSelectedDate] = useState<Date | null>( isValidDate( value )
    ? new Date( value ) : null );

  const handleChange = ( e: Date | null ) => {
    setSelectedDate( e );
    onChange( e?.toISOString() );
  };

  return (
    <DatePicker
      selected={selectedDate}
      locale="es"
      onChange={handleChange}
      customInput={(
        <CustomInput {...rest} />
      )}
    />
  );
}

export default DateColumn;
